import { TranslationsInstance as i18n } from './locale/i18n';
import { membersAreaApps } from './members-area-apps';
export const DEFAULT_STATICS_VERSION = '1.322.0';
const DEFAULT_LOCALE = 'en';
const getStaticsUrl = async (editorSDK) => {
    const artifactsInfo = await editorSDK?.info?.getArtifactsUrls('', [
        'members-area-app-definitions',
    ]);
    const artifactUrl = artifactsInfo?.['members-area-app-definitions'];
    const fallbackUrl = `https://static.parastorage.com/services/members-area-app-definitions/${DEFAULT_STATICS_VERSION}/`;
    return artifactUrl ? `${artifactUrl}/` : fallbackUrl;
};
const withDefaultProps = (app) => ({
    // @ts-expect-error
    numbers: {},
    showInLoginMenu: false,
    showInMemberMenu: true,
    social: false,
    socialHome: false,
    // @ts-expect-error
    urlOverride: null,
    ...app,
});
export const getAppDefinition = async ({ i18next, application, editorSDK, applicationsOptions, }) => {
    if ('page' in application) {
        return application;
    }
    const locale = (await editorSDK?.info?.getLanguage('')) ?? DEFAULT_LOCALE;
    const staticsUrl = await getStaticsUrl(editorSDK);
    await i18n.init(i18next, locale, staticsUrl);
    const membersAreaApp = membersAreaApps.find((app) => app.ids?.appDefinitionId === application.appDefinitionId &&
        (app.ids?.pageId === application.pageId ||
            app.ids?.widgetId === application.widgetId));
    const appDefinitionOptions = applicationsOptions?.find((options) => options?.id?.appDefinitionId === application.appDefinitionId &&
        options?.id?.pageId === application.pageId);
    const appDefinition = (membersAreaApp?.getDefinition(staticsUrl, i18n.t) ??
        application);
    const appDefinitionWithOptions = {
        ...appDefinition,
        ...appDefinitionOptions?.options,
    };
    return withDefaultProps(appDefinitionWithOptions);
};
export const getAppDefinitions = async ({ i18next, applications, editorSDK, applicationsOptions, }) => {
    const appDefinitions = [];
    for (const application of applications) {
        const appDef = await getAppDefinition({
            i18next,
            application,
            editorSDK,
            applicationsOptions,
        });
        appDefinitions.push(appDef);
    }
    return appDefinitions;
};
//# sourceMappingURL=getAppDefinition.js.map